import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import NewProject from "@/pages/NewProject";
import ProjectView from "@/pages/ProjectView";
import History from "@/pages/History";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Legal from "@/pages/Legal";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import UseCase from "@/pages/UseCase";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App bg-blueprint min-h-screen flex flex-col">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/nouveau" element={<NewProject />} />
            <Route path="/historique" element={<History />} />
            <Route path="/projet/:id" element={<ProjectView />} />
            <Route path="/tarifs" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/legal/:section" element={<Legal />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/planning-renovation" element={<UseCase slug="planning-renovation" />} />
            <Route path="/planning-construction-maison" element={<UseCase slug="planning-construction-maison" />} />
            <Route path="/planning-btp-tertiaire" element={<UseCase slug="planning-btp-tertiaire" />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
